import { useSearchParams } from 'react-router-dom';

export const useIsAdminTemplateInterview = () => {
  const [searchParams] = useSearchParams();
  return searchParams.get('isAdminTemplate') === 'true';
};

export const useIsTemplateInterview = () => {
  const [searchParams] = useSearchParams();
  return searchParams.get('isTemplate') === 'true';
};
